const en = {
  auth: {
    signingIn: 'Checking sign in status...',
    loading: 'Loading...',
    signInButton: 'Sign in',
    inactivityError: 'You were logged out due to inactivity. Please log in again',
  },
  certificationTest: {
    retakeCertificationTestTitle: 'Recertification',
    retakeCertificationTestDescription:
      'If you are about to retake a certification, your old grade will be erased, are you sure?',
  },
  notifications: {
    error: 'Oops...',
    success: 'Success!',
    requestIsProcessing: 'Your request is processing',
    user: {
      success: {
        description: 'User has been successfully updated.',
      },
      error: {
        description: 'An error occurred during the user update.',
      },
    },
  },
}

export default en
export type Translations = typeof en
